import { render, staticRenderFns } from "./NewFormDialog.vue?vue&type=template&id=f749b776"
import script from "./NewFormDialog.vue?vue&type=script&lang=ts"
export * from "./NewFormDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports